export default {
  form: {
    agreement: {
      label:
        'Ik erken dat mijn elektronische goedkeuring gelijkwaardig is aan het ondertekenen van dit document en begrijp dat mijn elektronische handtekening bindend is.',
    },
    signed_by: {
      label: 'Naam',
      placeholder: 'Naam',
    },
    signer_first_name: {
      label: 'Voornaam',
      placeholder: 'Voornaam',
    },
    signer_last_name: {
      label: 'Achternaam',
      placeholder: 'Achternaam',
    },
    recipient_email: {
      label: 'E-mailadres ontvanger',
      placeholder: 'Voer e-mailadres in',
    },
    send_to_email: {
      label: 'Contract naar eigenaar sturen per e-mail ({{email}})',
    },
    additional_locations: {
      label: 'Extra locaties',
      placeholder: 'Zoek een toe te voegen locatie',
    },
    special_agreements: {
      label: 'Speciale afspraken',
      placeholder: 'Voer eventuele speciale afspraken in',
    },
  },
  labels: {
    name: 'Naam',
    date: 'Datum',
  },
  buttons: {
    sign_in_person: 'Hier samen met de eigenaar tekenen',
    back: 'Terug',
    edit_contract: 'Contract bewerken',
    skip: 'Overslaan',
    sign: 'Ondertekenen',
    init_sign: 'Contract aanmaken en verzenden',
    redo: 'Opnieuw',
    continue: 'Doorgaan',
    preview: 'Voorbeeld',
    submit: 'Indienen',
  },
  toasts: {
    failed_to_preview_contract: 'Contractvoorbeeld laden mislukt',
    contract_signing_pending: 'Even geduld, we starten je contract op...',
    failed_to_sign_contract: 'Contract starten mislukt ⁉️',
    contract_got_signed: 'Contract gestart 👌',
  },
  in_person_signing: {
    description:
      'De eigenaar heeft deze link per e-mail ontvangen en kan op afstand tekenen. Is de eigenaar nu bij u, open dan hier de ondertekenpagina.',
  },
  signature_link: {
    label: 'Handtekeninglink (dezelfde link die per e-mail naar de ontvanger is verzonden)',
    copy: 'Kopiëren',
    copied: 'Handtekeninglink gekopieerd naar klembord',
  },
  header: 'Contract aanmaken',
  description: 'Controleer de contractdetails en voer het e-mailadres in waarnaar het contract moet worden verzonden.',
};
